import React from 'react';
import PropTypes from 'prop-types';
import { Form as FormikForm, FormItem, Select, Radio } from 'formik-antd';
import { orgTypes, sectors } from 'utils/roles-sectors';
import { DB_PREFIX } from './constants';

const Form = ({ children }) => {
  return (
    <FormikForm layout="vertical">
      <FormItem
        label="What type of business are you"
        name={`${DB_PREFIX}.type`}
      >
        <Radio.Group defaultValue="" name={`${DB_PREFIX}.type`}>
          {orgTypes.map((item) => (
            <Radio.Button value={item.name}>{item.label}</Radio.Button>
          ))}
        </Radio.Group>
      </FormItem>
      <FormItem
        label="What service(s) do you provide"
        name={`${DB_PREFIX}.service`}
      >
        <Select name={`${DB_PREFIX}.service`}>
          {sectors.map(({ name, label }) => (
            <Select.Option key={name} value={name}>
              {label}
            </Select.Option>
          ))}
        </Select>
      </FormItem>
      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
};

Form.defaultProps = {
  children: null,
};

export default Form;
